import { createActions } from 'reflux';

const signupActions = createActions([
  'signup'
]);

export default signupActions;
